"use client";
import { useMemo } from "react";

import { loadStripePromise, Elements } from "@stadium/services/stripe";

export const StripeWrapper = ({ children, stripeKey, ...rest }) => {
  const loadedStripePromise = useMemo(() => loadStripePromise(stripeKey), [stripeKey]);
  return (
    <Elements stripe={loadedStripePromise} {...rest}>
      {children}
    </Elements>
  );
};
